import {EntityService} from '../../../service/EntityService';

export class TaxService extends EntityService {

  static entity = 'app/tax';

}
